import { filter } from "rxjs";

import type { OperatorFunction } from "rxjs";

export function filterNullable<T>(): OperatorFunction<T | null | undefined, T> {
  return filter((v): v is T => v != null);
}
